
if (!customElements.get('pc-qv-spec-items')) {
  customElements.define('pc-qv-spec-items', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.prepare());
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); }
    prepare() {
      if (this.prepared) return;
      const full = this.querySelector('.pc-qv-specifications__full');
      const preview = this.querySelector('.pc-qv-specifications__preview');
      const details = this.querySelector('details');
      const summary = details && details.querySelector('summary');
      if (!full || !preview || !summary) return;
      this.prepared = true;
      const copy = full.cloneNode(true);
      // Count top-level bullets, data rows, or standalone paragraphs.
      // Nested paragraphs inside bullets/rows are part of that same item.
      const items = Array.from(copy.querySelectorAll('li,tr,p')).filter(item => {
        if (!item.textContent.trim()) return false;
        if (item.parentElement.closest('li,tr,p')) return false;
        if (item.tagName === 'TR' && (item.closest('thead') || !item.querySelector('td'))) return false;
        return true;
      });
      // Unknown markup and short lists remain fully visible without a needless toggle.
      if (items.length <= 4) return;
      const range = document.createRange();
      range.setStart(copy, 0);
      range.setEndAfter(items[3]);
      const firstSix = range.cloneContents();
      firstSix.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      firstSix.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
      preview.replaceChildren(firstSix);
      preview.hidden = false;
      summary.hidden = false;
      details.open = false;
    }
  });
}
